module.exports = __webpack_public_path__ + "img/azi_picture.310ef7bb.jpeg";